import { createPageApp } from '@/lib/createPageApp'
import SeminarDescriptionPage from './SeminarDescriptionPage.vue'

createPageApp(SeminarDescriptionPage).mount()
